import { useLocation } from 'react-router-dom-v5-compat';

import { useCustomerHasAccessToPerformance } from 'src/store';
import { PAGE_VIEW } from 'src/views/PerformancePage/const';

export const useRouteShouldHideOverflow = () => {
  const { pathname } = useLocation();

  const customerHasAccessToPerformance = useCustomerHasAccessToPerformance();

  return customerHasAccessToPerformance && pathname.includes(PAGE_VIEW.channels);
};
